module.exports = __webpack_public_path__ + "static/media/roxana_irinei.84fa6ac9.jpg";